var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "meeting-panel", attrs: { id: "meeting-detail" } },
    [
      _c("header", { staticClass: "meeting-panel-header" }, [
        _vm.view !== "MAIN"
          ? _c(
              "button",
              {
                staticClass: "icon-action",
                attrs: {
                  type: "button",
                  "aria-label": _vm.scheduledMeeting.meetingName,
                  title: _vm.scheduledMeeting.meetingName
                },
                on: {
                  click: function($event) {
                    _vm.view = "MAIN"
                  }
                }
              },
              [_c("portal-icon", { attrs: { name: "arrow-left", size: 18 } })],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "meeting-title" },
          [
            _c(
              "portal-status-pill",
              {
                attrs: {
                  background: _vm.isCancelled
                    ? "var(--v-alert_10-base)"
                    : "var(--v-success_10-base)",
                  color: _vm.isCancelled
                    ? "var(--v-alert-base)"
                    : "var(--v-success-base)"
                }
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.isCancelled
                        ? _vm.$t("meetings.detail.cancelled")
                        : _vm.$t("meetings.filter.scheduled")
                    ) +
                    " "
                )
              ]
            ),
            _c("h1", [_vm._v(_vm._s(_vm.scheduledMeeting.meetingName))])
          ],
          1
        ),
        _c(
          "button",
          {
            staticClass: "icon-action close-action",
            attrs: {
              type: "button",
              "aria-label": _vm.$t("global.close"),
              title: _vm.$t("global.close")
            },
            on: {
              click: function($event) {
                return _vm.$emit("result")
              }
            }
          },
          [_c("portal-icon", { attrs: { name: "x", size: 19 } })],
          1
        )
      ]),
      !_vm.isReady
        ? _c(
            "div",
            { staticClass: "meeting-panel-loading" },
            [
              _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  size: 36,
                  width: 3,
                  color: "primary"
                }
              })
            ],
            1
          )
        : _vm.view === "MAIN"
        ? _c("main", { staticClass: "meeting-panel-body show-scrollbar" }, [
            _c(
              "section",
              {
                staticClass: "schedule-card",
                class: { cancelled: _vm.isCancelled }
              },
              [
                _c(
                  "span",
                  { staticClass: "schedule-icon" },
                  [
                    _c("portal-icon", {
                      attrs: { name: "calendar-days", size: 21 }
                    })
                  ],
                  1
                ),
                _c("div", [
                  _c("span", [_vm._v(_vm._s(_vm.$t("meetings.detail.time")))]),
                  _c("strong", { class: { strike: _vm.isCancelled } }, [
                    _vm._v(_vm._s(_vm.formattedStart))
                  ]),
                  _c("small", [
                    _vm._v(
                      _vm._s(_vm.durationMinutes) +
                        " " +
                        _vm._s(_vm.$t("meetings.detail.minutes"))
                    )
                  ])
                ])
              ]
            ),
            _c("section", { staticClass: "panel-section" }, [
              _c("h2", [_vm._v(_vm._s(_vm.$t("meetings.booked.booked-by")))]),
              _c("div", { staticClass: "detail-list" }, [
                _c("div", { staticClass: "detail-row" }, [
                  _c(
                    "span",
                    { staticClass: "detail-icon" },
                    [
                      _c("portal-icon", {
                        attrs: { name: "user-round", size: 17 }
                      })
                    ],
                    1
                  ),
                  _c("div", [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("meetings.detail.name")))
                    ]),
                    _c("strong", [_vm._v(_vm._s(_vm.contactName))])
                  ])
                ]),
                _c(
                  "a",
                  {
                    staticClass: "detail-row",
                    attrs: {
                      href: "mailto:" + _vm.scheduledMeeting.formData.email
                    }
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "detail-icon" },
                      [
                        _c("portal-icon", { attrs: { name: "mail", size: 17 } })
                      ],
                      1
                    ),
                    _c("div", [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("meetings.detail.email")))
                      ]),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.scheduledMeeting.formData.email))
                      ])
                    ])
                  ]
                ),
                _vm.scheduledMeeting.formData.phone
                  ? _c(
                      "a",
                      {
                        staticClass: "detail-row",
                        attrs: {
                          href: "tel:" + _vm.scheduledMeeting.formData.phone
                        }
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "detail-icon" },
                          [
                            _c("portal-icon", {
                              attrs: { name: "phone", size: 17 }
                            })
                          ],
                          1
                        ),
                        _c("div", [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("meetings.detail.phone")))
                          ]),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.scheduledMeeting.formData.phone))
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ])
            ]),
            _vm.locationType
              ? _c("section", { staticClass: "panel-section" }, [
                  _c("h2", [_vm._v(_vm._s(_vm.locationHeading))]),
                  _c("div", { staticClass: "location-card" }, [
                    _c(
                      "span",
                      { staticClass: "detail-icon location-icon" },
                      [
                        _c("portal-icon", {
                          attrs: { name: _vm.locationIcon, size: 18 }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "location-copy" },
                      [
                        _vm.locationType === "Zoom" &&
                        _vm.scheduledMeeting.zoomMeeting
                          ? [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      _vm.scheduledMeeting.zoomMeeting.join_url,
                                    target: "_blank",
                                    rel: "noopener"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("meetings.detail.join")) +
                                      " "
                                  ),
                                  _c("portal-icon", {
                                    attrs: { name: "external-link", size: 14 }
                                  })
                                ],
                                1
                              ),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.scheduledMeeting.zoomMeeting.join_url
                                  )
                                )
                              ]),
                              _c("small", [
                                _vm._v(
                                  _vm._s(_vm.$t("meetings.detail.id")) +
                                    " " +
                                    _vm._s(_vm.scheduledMeeting.zoomMeeting.id)
                                )
                              ]),
                              _vm.scheduledMeeting.zoomMeeting.pstnPassword
                                ? _c("small", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("meetings.detail.passcode")
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.scheduledMeeting.zoomMeeting
                                            .pstnPassword
                                        ) +
                                        " "
                                    )
                                  ])
                                : _vm._e(),
                              _vm.zoomDialIn
                                ? _c("small", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("meetings.detail.dial-in")
                                        ) +
                                        " " +
                                        _vm._s(_vm.normalizedZoomDialIn) +
                                        " "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          : _vm.locationType === "Google" &&
                            _vm.scheduledMeeting.googleMeeting
                          ? [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      _vm.scheduledMeeting.googleMeeting
                                        .hangoutLink,
                                    target: "_blank",
                                    rel: "noopener"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("meetings.detail.join")) +
                                      " "
                                  ),
                                  _c("portal-icon", {
                                    attrs: { name: "external-link", size: 14 }
                                  })
                                ],
                                1
                              ),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.scheduledMeeting.googleMeeting
                                      .hangoutLink
                                  )
                                )
                              ]),
                              _vm.googleDialIn
                                ? _c("small", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("meetings.detail.dial-in")
                                        ) +
                                        " " +
                                        _vm._s(_vm.googleDialIn.label) +
                                        " (" +
                                        _vm._s(_vm.googleDialIn.regionCode) +
                                        ") "
                                    )
                                  ])
                                : _vm._e(),
                              _vm.googleDialIn
                                ? _c("small", [
                                    _vm._v(
                                      _vm._s(_vm.$t("meetings.detail.pin")) +
                                        " " +
                                        _vm._s(_vm.googleDialIn.pin)
                                    )
                                  ])
                                : _vm._e()
                            ]
                          : _c("strong", [
                              _vm._v(_vm._s(_vm.locationDescription))
                            ])
                      ],
                      2
                    )
                  ])
                ])
              : _vm._e(),
            _vm.hasAnswers
              ? _c(
                  "section",
                  { staticClass: "panel-section answer-section" },
                  _vm._l(_vm.scheduledMeeting.formData.answers, function(
                    answer,
                    index
                  ) {
                    return _c(
                      "div",
                      { key: index, staticClass: "answer-card" },
                      [
                        _c("label", [
                          _vm._v(_vm._s(_vm.questionText(answer.question)))
                        ]),
                        _c("p", [_vm._v(_vm._s(answer.answer))])
                      ]
                    )
                  }),
                  0
                )
              : _vm._e()
          ])
        : _c(
            "div",
            { staticClass: "meeting-frame" },
            [
              _c("i-frame-wrapper", {
                attrs: {
                  "frame-url":
                    _vm.view === "CANCEL" ? _vm.cancelUrl : _vm.rescheduleUrl
                },
                on: { "frame-event": _vm.frameEvent }
              })
            ],
            1
          ),
      _vm.isReady && _vm.view === "MAIN" && !_vm.isCancelled
        ? _c("footer", { staticClass: "meeting-panel-footer" }, [
            _c(
              "button",
              {
                staticClass: "cancel-action",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    _vm.view = "CANCEL"
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.$t("meetings.detail.cancel")) + " ")]
            ),
            _c(
              "button",
              {
                staticClass: "reschedule-action",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    _vm.view = "RESCHEDULE"
                  }
                }
              },
              [
                _c("portal-icon", {
                  attrs: { name: "calendar-days", size: 16 }
                }),
                _vm._v(" " + _vm._s(_vm.$t("meetings.detail.reschedule")) + " ")
              ],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }